import { memo } from "react";
import { useEntitiesById } from "@hooks/useEntities";
import { DateRangeDisplay } from "@components/settings/OrganizationCloseTemplates/DateRangeDisplay";
import { VStack } from "@design-system/VStack/VStack";

interface CloseSelectOptionProps {
    name: string;
    entityId?: number;
    clientName?: string;
    startDate: string | null;
    endDate: string | null;
}

/**
 * Close option label for the FilterMultiselect in TaskCloseFilter. Shows the
 * close name with the entity and date range below it when available. Picker
 * rows use `CloseSelectItem`.
 */
export const CloseSelectOption = memo(
    ({
        entityId,
        clientName,
        name,
        startDate,
        endDate,
    }: CloseSelectOptionProps) => {
        const hasDate = startDate != null || endDate != null;
        const entitiesById = useEntitiesById();
        const entity = entityId ? entitiesById.get(entityId) : null;
        const subtitle = entity?.name ?? clientName;

        return (
            <VStack gap={4}>
                <div>{name}</div>
                {subtitle && (
                    <div className="text-gray-500 text-sm">{subtitle}</div>
                )}
                {hasDate && (
                    <div className="text-gray-500 text-sm">
                        <DateRangeDisplay
                            startDate={startDate}
                            endDate={endDate}
                        />
                    </div>
                )}
            </VStack>
        );
    },
);
